module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/143.3abb6403.png";